export default class Error {
    /**
     * To Create Instance
     * @constructor
     * @param {object} errors - Number of Error Object
     */
    constructor(errors = {}) {
        this.errors = errors;
    }
    /**
     * To Check object has Error
     * @param {string} field - The name of key or field
     * @return {object}
     */
    has(field) {
        if(Object.prototype.hasOwnProperty.call(this.errors, field)){
            return Object.prototype.hasOwnProperty.call(this.errors, field);
        }
        return Object.keys(this.errors).some(k => k === field || k.startsWith(field + '.'));
    }
    /**
     * To get specific key object
     * @param {string} field - The name of key or field
     * @return {object}
     */
    get(field) {
        if (Object.prototype.hasOwnProperty.call(this.errors, field)) {
            return this.errors[field];
        }
        const keys = Object.keys(this.errors).filter(k => k.startsWith(field + '.'));
        if (keys.length){
            return this.errors[keys[0]];
        } 
        return null;
    }
    /**
     * To first value of specific key object
     * @param {string} field - The name of key or field
     * @return {object}
     */
    first(field) {
        const msgs = this.get(field);
        if (!msgs) return null;
        return msgs.join(', ');
    }
    /**
     * To return whole errors from object
     * @return {object}
     */
    all() {
        return this.errors;
    }
    /**
     * To remove a specific key object
     * @param {string} field - The name of key or field
     * @return {object}
     */
    remove(field) {
        this.clear(field);
    }    
    /**
     * To clear all errors
     * @return {object}
     */
    clear(field) {
        if (field) {
            delete this.errors[field];
            return;
        }else{
            const keys = Object.keys(this.errors).filter(k => k.startsWith(field + '.'));
            keys.forEach(key => delete this.errors[key]);
            return;
        }
    }
    /**
     * To check if there are any errors
     * @return {boolean}
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }
}